export default {
  required: 'Please enter',
  requiredSelect: 'Please select',
  basicInfo: 'Basic Info',
  serviceProvider: 'Service Provider',
  serviceProviderPlaceholder: 'Please select service provider',
  apiKey: 'API Key',
  apiKeyPlaceholder: 'Please enter activity ID',
  apiSecret: 'API Secret',
  apiSecretPlaceholder: 'Please enter activity ID',
  smsSignature: 'SMS Signature',
  smsSignaturePlaceholder: 'Please enter activity ID',
  channelConfig: 'Overseas Channel',
  addChannel: 'Add Channel',
  countryRegion: 'Country/Region',
  operator: 'Operator',
  operatorPlaceholder: 'Please select',
  templateCode: 'Template Code',
  templateCodePlaceholder: 'Please enter template code',
  status: 'Status',
  actions: 'Actions',
  edit: 'Edit',
  delete: 'Delete',
  sendTest: 'Send Test',
  testPhone: 'Please enter mobile number',
  sendTestSms: 'Send Test SMS',
  sendTestSuccess: 'Test SMS sent successfully',
  sendTestFail: 'Failed to send test SMS',
  save: 'Save Config',
  saveSuccess: 'Saved successfully',
  deleteConfirm: 'Confirm to delete this channel?',
  deleteSuccess: 'Deleted successfully',
  selectChannel: 'Please select a channel',
  // Tab
  tabConfig: 'SMS Config',
  tabSendLog: 'Send Logs',
  // Log filter
  logMobile: 'Mobile',
  logMobilePlaceholder: 'Enter mobile number',
  logTemplateCode: 'Template Code',
  logTemplateCodePlaceholder: 'Enter template code',
  logStatus: 'Status',
  logStatusAll: 'All Status',
  logStatusSuccess: 'Success',
  logStatusFailed: 'Failed',
  logProvider: 'Provider',
  logProviderAll: 'All Providers',
  logSendTime: 'Send Time',
  logStartDate: 'Start Date',
  logEndDate: 'End Date',
  logSearch: 'Search',
  logReset: 'Reset',
  logCollapse: 'Collapse',
  logExpand: 'Expand',
  logAllCountries: 'All Countries/Regions',
  // Log table
  logColumnCountry: 'Country/Region',
  logColumnMobile: 'Mobile',
  logColumnTemplateCode: 'Template Code',
  logColumnProvider: 'Provider',
  logColumnStatus: 'Status',
  logColumnSendTime: 'Send Time',
  logColumnMessageId: 'Provider Message ID',
  logColumnActions: 'Actions',
  logDetail: 'Detail',
  // Stats cards
  statTotalCount: 'Total Sent',
  statSuccessCount: 'Success',
  statFailedCount: 'Failed',
  statSuccessRate: 'Success Rate',
  // Detail drawer
  detailTitle: 'SMS Send Detail',
  detailMobile: 'Mobile',
  detailCountry: 'Country/Region',
  detailProvider: 'Provider',
  detailTemplateCode: 'Template Code',
  detailTemplateName: 'Template Name',
  detailContent: 'SMS Content',
  detailStatus: 'Send Status',
  detailMessageId: 'Provider Message ID',
  detailRequestId: 'Platform Request ID',
  detailSendTime: 'Send Time',
  detailCallbackTime: 'Callback Time',
  detailResponse: 'Response',
  detailErrorCode: 'Error Code',
  detailErrorMsg: 'Error Message',
  detailClose: 'Close',
  detailNone: '-',
};
